import React from "react";
import { cn } from "../../../lib/utils";

type MapLegendSwatchProps = {
  label: string;
  color?: string | null;
  representation?: "fill" | "line" | "circle" | "symbol" | "fill-extrusion" | null;
  iconToken?: string | null;
  iconPreviewUrl?: string | null;
  iconSdf?: boolean | null;
  className?: string;
  iconClassName?: string;
}

export function MapLegendSwatch({
  label,
  color,
  representation,
  iconToken,
  iconPreviewUrl,
  iconSdf,
  className,
  iconClassName,
}: MapLegendSwatchProps) {
  if (representation === "line") {
    return (
      <div className={cn("flex h-5 w-7 items-center justify-center", className)}>
        <div
          className="h-0.5 w-full rounded-full border border-transparent"
          style={{ backgroundColor: color || "var(--muted-foreground)" }}
        />
      </div>
    );
  }

  if (representation === "symbol") {
    return (
      <div
        className={cn(
          "relative flex h-9 w-9 items-center justify-center rounded-md border border-border/70 bg-background shadow-sm",
          className,
        )}
        title={iconToken || label}
      >
        {iconPreviewUrl ? (
          iconSdf ? (
            <span
              aria-label={`Legend icon for ${label}`}
              role="img"
              className={cn("h-7 w-7", iconClassName)}
              style={{
                backgroundColor: color || "var(--foreground)",
                WebkitMaskImage: `url(${iconPreviewUrl})`,
                maskImage: `url(${iconPreviewUrl})`,
                WebkitMaskRepeat: "no-repeat",
                maskRepeat: "no-repeat",
                WebkitMaskPosition: "center",
                maskPosition: "center",
                WebkitMaskSize: "contain",
                maskSize: "contain",
              }}
            />
          ) : (
            <img
              src={iconPreviewUrl}
              alt={`Legend icon for ${label}`}
              className={cn("h-7 w-7 object-contain", iconClassName)}
              style={{ imageRendering: "crisp-edges" }}
            />
          )
        ) : (
          <span className="text-[11px] font-black uppercase leading-none text-muted-foreground">
            {iconToken?.slice(0, 2) || "?"}
          </span>
        )}
        {!iconSdf && (
          <div
            className="absolute -bottom-1 -right-1 h-3.5 w-3.5 rounded-full border-2 border-card shadow-sm"
            style={{ backgroundColor: color || "var(--muted)" }}
          />
        )}
      </div>
    );
  }

  return (
    <div className={cn("flex h-5 w-5 items-center justify-center", className)}>
      <div
        className={cn(
          "border border-black/10 shadow-sm",
          representation === "fill" || representation === "fill-extrusion" ? "h-4 w-4 rounded-sm" : "h-4 w-4 rounded-full",
        )}
        style={{ backgroundColor: color || "var(--muted)" }}
      />
    </div>
  );
}
